import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { Path, useWatch } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useRequirementsModalStore } from '../stores/requirementsModalStore';
import { RequirementPanel } from './RequirementsPanel';
import { FieldValues } from 'react-hook-form';
import { BlankRequirementSection } from './BlankRequirementSection';

export function ProfileRequirementsSection<T extends FieldValues>({ readOnly = false }: { readOnly?: boolean } = {}) {
  const { control } = useFormContext<T>();
  const { openModal } = useRequirementsModalStore();
  const guidelines =
    useWatch({
      control,
      name: 'settings.guidelines' as Path<T>
    }) || [];

  return (
    <Flex flexDirection="column">
      <Flex justifyContent="space-between" alignItems="center">
        <Flex flexDirection="column">
          <Text
            variant="h6"
            sx={{
              lineHeight: '24px'
            }}
          >
            Brand and Regulatory Requirements
          </Text>
          <Text
            variant="body1"
            sx={{
              marginTop: '4px'
            }}
          >
            Define requirements that should be followed when creating content based on this profile.
          </Text>
        </Flex>

        <SlButton variant="contained" onClick={() => !readOnly && openModal(guidelines.length)} disabled={readOnly}>
          + Add Requirement
        </SlButton>
      </Flex>

      {guidelines.length === 0 ? (
        <BlankRequirementSection readOnly={readOnly} onAddClick={() => openModal(guidelines.length)} />
      ) : (
        <Flex
          flexDirection="column"
          sx={{
            marginTop: '32px',
            gap: '16px'
          }}
        >
          {guidelines.map((guideline, index) => (
            <RequirementPanel key={index} guideline={guideline} index={index} />
          ))}
        </Flex>
      )}
    </Flex>
  );
}
